module.exports = __webpack_public_path__ + "img/map-location.dc77b4ff.svg";